import React from "react";

type ChannelCardProps = {
    channel: {
        _id: string;
        name: string;
        description?: string;
        platform?: "telegram" | "discord" | "slack" | string;
        telegram_chat_id?: string; // optional, if you want to show username
        logoUrl?: string; // if you store channel logo/avatar
    };
};

const getPlatformBadge = (platform?: string) => {
    if (platform === "telegram") {
        return { label: "Telegram", className: "bg-sky-500/15 text-sky-300 border-sky-500/40" };
    }
    if (platform === "discord") {
        return { label: "Discord", className: "bg-indigo-500/15 text-indigo-300 border-indigo-500/40" };
    }
    if (platform === "slack") {
        return { label: "Slack", className: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" };
    }
    return { label: "Platform", className: "bg-dark-primary text-text-secondary border-dark-border" };
};

const ChannelCard: React.FC<{ channel: ChannelCardProps["channel"] }> = ({ channel }) => {
    const badge = getPlatformBadge(channel.platform);

    return (
        <div
            key={channel._id}
            className="border border-dark-tertiary rounded-lg p-4 space-y-3 hover:border-golden-accent transition-colors"
        >
            {/* Channel Header */}
            <div className="flex items-center gap-3">

                <div className="w-12 h-12 rounded-full bg-dark-tertiary flex items-center justify-center text-text-disabled">
                    {channel.name.charAt(0).toUpperCase()}
                </div>

                <div className="space-y-1">
                    <h3 className="text-lg font-semibold text-text-primary">{channel.name}</h3>
                    <span className={`inline-flex items-center text-xs px-2 py-0.5 rounded-full border ${badge.className}`}>
                        {badge.label}
                    </span>
                </div>
            </div>

            {/* Channel Description */}
            {channel.description && (
                <p className="text-sm text-text-secondary break-words whitespace-pre-line">
                    {channel.description}
                </p>
            )}
        </div>
    );
};

export default ChannelCard;
